/**
 * @file Textarea.js
 * @version 2.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2025-11-11
 * @modified 2026-09-09
 * @description Reusable styled textarea component
 *
 * Matches the Input component pattern for consistency
 */

import React from 'react';
import './Textarea.css';

/**
 * Textarea Component
 *
 * @param {string} value - Textarea value
 * @param {function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {number} rows - Number of visible rows (default: 4)
 * @param {number} maxLength - Maximum character length
 * @param {boolean} required - Whether the field is required
 * @param {boolean} disabled - Whether the textarea is disabled
 * @param {string} className - Additional CSS classes
 * @param {string} icon - Optional Material Symbols icon name
 * @param {Object} rest - Other textarea props
 */
function Textarea({
  value,
  onChange,
  placeholder,
  rows = 4,
  maxLength,
  required = false,
  disabled = false,
  className = '',
  icon,
  ...rest
}) {
  return (
    <div className={`textarea-wrapper ${className}`}>
      {icon && (
        <span className="textarea-icon material-symbols-rounded">{icon}</span>
      )}
      <textarea
        className={`styled-input ${icon ? 'with-icon' : ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        required={required}
        disabled={disabled}
        {...rest}
      />
      {maxLength && (
        <div className="textarea-counter">
          {value?.length || 0} / {maxLength}
        </div>
      )}
    </div>
  );
}

export default Textarea;
